/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Transition, SwitchTransition } from 'react-transition-group';
import { Avatar, Icon, Tooltip } from '../../../../../components';
import { ReadOnlyWithLexicalTags } from '../ReadOnlyWithLexicalTags';
import { ReactComponent as Logo } from '../../../../../assets/images/logo-chat.svg';

const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const BaseMessageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;

const AssetContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
`;

const StyledAvatar = styled(Avatar)`
  align-self: flex-start;
`;

const StyledLogo = styled(Logo)`
  flex-shrink: 0;
  align-self: flex-start;
`;

const StyledTooltip = styled(Tooltip)`
  margin-left: auto;
`;

const QuestionAction = styled(Icon)`
  cursor: pointer;
  border-radius: 4px;
  &:hover {
    background: var(--wash-gray-hover);
  }
  padding: 2px;
`;

const AnimatedTextWrapper = styled.div`
  transition: opacity 600ms linear;
  opacity: ${({ $state }) => ($state === 'entered' || $state === 'entering' ? 1 : 0)};
`;

// Simple text display component for agentic chats
const SimpleTextDisplay = styled.div`
  margin: 0;
  font-family: var(--font-family-body);
  color: var(--content-body);
  font-size: 13px;
  line-height: 24px;
  font-style: normal;
  letter-spacing: -0.02em;
  font-weight: 400;
  white-space: pre-wrap;
  word-break: break-word;
`;

const Message = ({
  text,
  onUndoClick,
  avatarURL = null,
  asset = null,
  isLastClarifyQuestion = false,
  isAgenticChat = false
}) => (
  <MessageContainer>
    <BaseMessageContainer>
      {!avatarURL ? <StyledLogo /> : <StyledAvatar src={avatarURL} alt='user' width={24} />}
      <AssetContainer>
        <SwitchTransition>
          <Transition key={text} timeout={600} mountOnEnter unmountOnExit>
            {(state) => (
              <AnimatedTextWrapper $state={state}>
                {isAgenticChat ? (
                  <SimpleTextDisplay>{text}</SimpleTextDisplay>
                ) : (
                  <ReadOnlyWithLexicalTags text={text} namespace='QuestionItem' />
                )}
              </AnimatedTextWrapper>
            )}
          </Transition>
        </SwitchTransition>
        {asset}
        {isLastClarifyQuestion && (
          <StyledTooltip content='Remove this question'>
            <QuestionAction
              name='trash'
              color='var(--content-subtitle)'
              displaySize={20}
              onClick={onUndoClick}
            />
          </StyledTooltip>
        )}
      </AssetContainer>
    </BaseMessageContainer>
  </MessageContainer>
);

Message.propTypes = {
  text: PropTypes.string.isRequired,
  asset: PropTypes.node,
  avatarURL: PropTypes.string,
  isLastClarifyQuestion: PropTypes.bool,
  isAgenticChat: PropTypes.bool,
  onUndoClick: PropTypes.func
};

export { Message };
